/**
 * CLC TA API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TAStatus = {
    InProgress: 'InProgress',
    PendingApproval: 'PendingApproval',
    TravelApproved: 'TravelApproved',
    TravelRejected: 'TravelRejected',
    PendingAcquittal: 'PendingAcquittal',
    AcquittalComplete: 'AcquittalComplete',
    AcquittalApproved: 'AcquittalApproved',
    Finalised: 'Finalised',
    Cancelled: 'Cancelled',
    Deleted: 'Deleted',
    PendingCancelApproval: 'PendingCancelApproval',
    CancelApproved: 'CancelApproved'
} as const;
export type TAStatus = typeof TAStatus[keyof typeof TAStatus];

